import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        memberId: '', // 用户id
        bassMember: { loginName: '' }, // 个人信息 手机号码 邮箱 等
        memberInfo: { largePictureUrl: "" }, // 个人信息拓展信息 
        memberVocationInfos: [{ companyName: '', department: '', inputCompany: '', inputCompany: '', schoolNameStr: '' }], // 职业信息
        zjList: [], // 专家信息
        carts: '', // 购物车数量
        timeNum: 60,
        isAuthentication: '',
        typeNum: '',
        zIndex: 2000,
        IDcard: "",
        IDtype: "",
        ifShow: true,
        checkState: '',
        cancelTokenArr:[],
        latestDetail:{} // 最后一次实名认证的信息
    },
    mutations: {
        updateState(state, { key, value }) {
            state[key] = value
        },
        showIf(state, played) {
            state.ifShow = played
        },
        addCancelToken(state, cancel) {
            if (!state.cancelTokenArr) {
                state.cancelTokenArr = []
            }
            if (cancel) {
                state.cancelTokenArr.push(cancel)
            }
        },
        // 取消所有请求
        clearCancelToken(state) {
            state.cancelTokenArr.forEach(Clear => {
                if (Clear) {
                    Clear()
                }
            })
            state.cancelTokenArr = []
        }

    }
})


// WEBPACK FOOTER //
// ./src/store/store.js